<div class="content" *ngIf="orgData">
  <angular-org-chart id="orgChartId" [data]="orgData"></angular-org-chart>
</div>
